import { Link } from "react-router-dom";
import styles from "./Footer.module.css";
import { PhoneIcon, MailIcon, PinIcon } from "./icons";
import LogoMark from "./LogoMark";

function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.glow} aria-hidden="true" />

      <div className={styles.inner}>
        <div>
          <div className={styles.brand}>
            <LogoMark className={styles.brandMark} />
            BOI Gardens &amp; Car Cleaning
          </div>
          <p className={styles.tagline}>
            Local garden care and car cleaning for Kerikeri and the Bay of
            Islands — tidy sections, shining cars.
          </p>
        </div>

        <div className={styles.col}>
          <h4>Get in touch</h4>
          <div className={styles.contactRow}>
            <PhoneIcon /> +64 27 665 5450
          </div>
          <div className={styles.contactRow}>
            <MailIcon /> michael.j.crichton@gmail.com
          </div>
          <div className={styles.contactRow}>
            <PinIcon /> Kerikeri, New Zealand
          </div>
        </div>
      </div>

      <div className={styles.bottom}>
        © {new Date().getFullYear()} BOI Gardens &amp; Car Cleaning. Made with
        care in Kerikeri. · <Link to="/admin/login">Staff login</Link>
      </div>
    </footer>
  );
}

export default Footer;
